import React from 'react';
import { observer } from 'mobx-react';

// Helpers
import { getCookie } from '../../helpers/helpers.js'

// Translations
import translate from '../Translate.js';

// Dependencies
import { checkValidity } from '../../helpers/helpers.js'

// Components
import Step from '../Common/Step';
import CheckupStep from './CheckupStep';
import Drawer from '../Drawer/Drawer';

const CheckupForm = observer(class CheckupForm extends React.Component {
  constructor() {
    super();
    this.setStep = this.setStep.bind(this);
    this.nextStep = this.nextStep.bind(this);
    this.prevStep = this.prevStep.bind(this);
  }

  componentWillMount() {
    const { RegisterStore, SessionStore, SettingsStore } = this.props.store;

    this.state = {
      step: this.props.step || 1,
      locationSid: null,
      confirmedLocations: []
    }

    // Retrieve data from localStorage
    let registerData = null;

    if(SessionStore.hasSessionStorage) {
      registerData = sessionStorage.getItem('registerData');
    } else {
      registerData = getCookie('registerData');
    }

    if(registerData && typeof registerData !== 'undefined') {
      RegisterStore.getLocalStorage(JSON.parse(registerData));
    } else {
      RegisterStore.getProctorData();
    }

    // Get account settings
    SettingsStore.getUserSettings(this);
  }

  setStep(e, step) {
    e.preventDefault();

    this.setState({
      step
    });
  }

  nextStep(e) {
    if(e) {
      e.preventDefault();
    }

    const _this = this;

    setTimeout(function(){
      _this.props.routing.history.push('/checkup/step-0' + (_this.state.step + 1));
    });

    // this.setState({
    //   step: this.state.step + 1
    // });

    window.scrollTo(0, 0);
  }

  prevStep() {
    this.setState({
      step: this.state.step - 1
    });

    this.props.routing.history.push('/checkup/step-0' + (this.state.step - 1));
  }

  handleSubmit(e) {
    e.preventDefault();
  }

  render() {
    const { translation } = this.props;
    const { userData } = this.props.store.SessionStore;

    return(
      <div>
        <div className={`wrap block-form`}>

          {userData.forcePasswordReset &&
            <Step
              step={this.state.step}
              setStep={this.setStep}
              data={translation.steps_password}
              skippable={false}
            />
          }

          {!userData.forcePasswordReset &&
            <Step
              step={this.state.step}
              setStep={this.setStep}
              data={translation.steps}
              skippable={false}
            />
          }

          <CheckupStep
            step={this.state.step}
            checkValidity={checkValidity}
            nextStep={this.nextStep}
            prevStep={this.prevStep}
            parent={this}
            locationSid={this.state.locationSid}
            confirmedLocations={this.state.confirmedLocations}
            {...this.props}
          />
        </div>

        <Drawer
          content={this.state.drawerContent}
          isOpen={this.state.drawerOpen}
          parent={this} {...this.props}
          locationSid={this.state.locationSid}
          callback={this.getLocations}
          checkup={true}
        />
      </div>
    );
  }
})

export default translate('CheckupForm')(CheckupForm);



// WEBPACK FOOTER //
// ./src/app/components/Checkup/Form.js